import { useEffect } from "react";
import { PagesAccountCopyUiDisplay } from "./Display";
import { useGetAccountId } from "@dealer-center/ddc-api-account-fetch";

export const PagesAccountCopyUi = () => {
  const selectedDealer = useGetAccountId();

  useEffect(() => {
    document.title = "AccountCopy";
  }, []);
  if (!selectedDealer) {
    return <>No selected dealer</>;
  }
  return <PagesAccountCopyUiDisplay />;
};
